import React from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import Grid from "@material-ui/core/Grid";
import styles from "./DealerDeliveryRanges.module.scss";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import EditIcon from "../../../../shared/Edit/EditIcon";
import DeliverRangeAndPriceRow from "./deliveryRangesRow/DealerDeliveryRangesRow";
import { Button } from "@material-ui/core";
import OptionToggle from "./OptionToggle";
import { PricesApplied } from "../../../../shared/feedback/PricesApplied";

const DeliveryRangeTable = (props) => {
  const deliveryData = props.old ? props.oldDeliveryData : props.deliveryData;

  const old = props.old;
  const editable = props.editable;

  const fromNscDealerSearch =
    props.user.permissions.rolePermissions.hasOwnProperty(
      "deliveryRangesSubmit"
    ) && props.fromNscDealerSearch;

  return (
    <ValidatorForm onSubmit={() => props.onSubmit(old)}>
      {editable && deliveryData.showFreeDeliveryOption && (
        <div>
          <OptionToggle
            {...props}
            id={`freeDeliveryHeader_${props.old}`}
            header={props.t("dealerDeliveryBands.freeDeliveryHeader")}
            body={props.t("dealerDeliveryBands.freeDeliveryBody")}
            toggleName={`freeDelivery_${props.old}`}
            data={deliveryData.freeDelivery}
            action={() => props.freeDeliveryToggle(props.old)}
          />
        </div>
      )}
      <div className={`${styles.tableHeader} pagePaddingLeft pagePaddingRight`}>
        <Grid
          id="deliveryRangeTableHeader"
          container
          className={styles.divider}
        >
          <Grid item md={4}>
            <div className={styles.headerWrap}>
              <span>
                {`${props.t("dealerDeliveryBands.distance")} (${
                  props.distanceUnit
                }) `}
              </span>
            </div>
          </Grid>

          <Grid item md={4} className={styles.center}>
            <div className={styles.headerWrap}>
              {props.t("dealerDeliveryBands.delivery")}
            </div>
          </Grid>
          <Grid item md={4} className={`${styles.rowHeader} ${styles.right}`}>
            <HasPermissionTo
              perform={["deliveryRanges:write"]}
              permissions={props.user.permissions.rolePermissions}
              condition={editable}
              render={() => {
                return (
                  <div className={styles.headerWrap} data-testid="editCharge">
                    {props.t("dealerDeliveryBands.deliveryCharge")}
                    <EditIcon
                      id="Ranges"
                      onClick={() => props.editOnClick(old)}
                    />
                  </div>
                );
              }}
              noRender={() => {
                return (
                  <div className={styles.headerWrap}>
                    {props.t("dealerDeliveryBands.deliveryCharge")}
                  </div>
                );
              }}
            />
          </Grid>
        </Grid>
      </div>

      <div id="deliveryRangesRow" className={`${styles.tableBottom} `}>
        {deliveryData.deliveryRangeOptions &&
          deliveryData.deliveryRangeOptions.map((item, index) => {
            return (
              <div>
                <DeliverRangeAndPriceRow
                  user={props.user}
                  freeDeliveryRow={deliveryData.freeDelivery && index === 0}
                  old={old}
                  editable={!editable}
                  key={index}
                  rowNo={index}
                  dataRow={item}
                  editActive={props.isEditActive}
                  currency={props.currencySymbol}
                  index={index}
                  updateToggleStatus={props.updateToggleStatus}
                  onPriceChange={(e, index) =>
                    props.handlePriceChange(e, index, old)
                  }
                />
              </div>
            );
          })}
      </div>
      {editable && (
        <div>
          <OptionToggle
            {...props}
            id={`deliverInUKHeader_${props.old}`}
            header={
              props.user.market.toUpperCase() === "CHE"
                ? props.t("dealerDeliveryBands.doUDeliverHeaderChe")
                : props.t("dealerDeliveryBands.doUDeliverHeader")
            }
            body={props.t("dealerDeliveryBands.doUDeliverBody")}
            toggleName={`deliverInUK_${props.old}`}
            data={deliveryData.nonMainlandDelivery}
            action={() => props.deliverInNonMainLandToggle(props.old)}
          />
        </div>
      )}
      {editable && (
        <div
          id="doUDeliverDiv"
          className={`${styles.subSectionPriceBackGround} pagePaddingLeft pagePaddingRight`}
        >
          <span className={styles.headerWrap}>
            {`${props.t("dealerDeliveryBands.delveryChargeNational")} (${
              props.currencySymbol
            })`}
            &nbsp;
          </span>
          {props.isEditActive ? (
            <TextValidator
              style={{ borderRadius: "0px" }}
              name="nonMainlandDelivery"
              variant="outlined"
              value={
                deliveryData.nonMainlandDeliveryCharge === null
                  ? ""
                  : deliveryData.nonMainlandDeliveryCharge
              }
              onChange={(e) => props.handleDeliveryChargeChange(e, old)}
              validators={[
                "required",
                "minNumber:0",
                "isNumber",
                "isNumericWithTwoDecimalPlaces",
              ]}
              errorMessages={[
                props.t("nscDeliveryBands.required"),
                props.t("nscDeliveryBands.invalid"),
                props.t("nscDeliveryBands.invalid"),
                props.t("nscDeliveryBands.invalid"),
              ]}
            />
          ) : (
            <p>{deliveryData.nonMainlandDeliveryCharge}</p>
          )}
        </div>
      )}

      {editable && (
        <div>
          <OptionToggle
            {...props}
            id={`doUSellHeader_${props.old}`}
            header={props.t("dealerDeliveryBands.doUSellHeader")}
            body={props.t("dealerDeliveryBands.doUSellBody")}
            toggleName={`sellInternational_${props.old}`}
            data={deliveryData.sellInternational}
            action={() => props.sellInternationalToggle(props.old)}
          />
        </div>
      )}

      {editable && (
        <div>
          <OptionToggle
            {...props}
            id={`doUDeliverInterHeader_${props.old}`}
            header={props.t("dealerDeliveryBands.doUDeliverInHeader")}
            body={props.t("dealerDeliveryBands.doUDeliverInBody")}
            toggleName={`deliverInternational${props.old}`}
            data={deliveryData.deliverInternational}
            action={() => props.deliverInternationalToggle(props.old)}
          />
        </div>
      )}

      {editable && (
        <div
          id="doUDeliverInterDiv"
          className={`${styles.subSectionPriceBackGround} pagePaddingLeft pagePaddingRight`}
        >
          <span className={styles.headerWrap}>
            {`${props.t("dealerDeliveryBands.delveryChargeInterNational")} (${
              props.currencySymbol
            })`}
            &nbsp;
          </span>
          {props.isEditActive ? (
            <TextValidator
              style={{ borderRadius: "0px" }}
              name="deliverInternationalText"
              variant="outlined"
              value={
                deliveryData.deliverInternationalCharge === null
                  ? ""
                  : deliveryData.deliverInternationalCharge
              }
              onChange={(e) => props.handleInternationalCharge(e, old)}
              validators={[
                "required",
                "minNumber:0",
                "isNumber",
                "isNumericWithTwoDecimalPlaces",
              ]}
              errorMessages={[
                props.t("nscDeliveryBands.required"),
                props.t("nscDeliveryBands.invalid"),
                props.t("nscDeliveryBands.invalid"),
                props.t("nscDeliveryBands.invalid"),
              ]}
            />
          ) : (
            <p>{deliveryData.deliverInternationalCharge}</p>
          )}
        </div>
      )}

      {editable && (
        <div className={styles.actionSection}>
          {props.enableSaveButton ? (
            <HasPermissionTo
              perform={["deliveryRanges:write"]}
              permissions={props.user.permissions.rolePermissions}
              render={() => {
                return (
                  <Button
                    type="submit"
                    id="savePricing"
                    className={
                      fromNscDealerSearch
                        ? styles.disableSaveBtn
                        : styles.saveBtn
                    }
                    data-testid="savePricing"
                    disabled={props.user.readOnly || fromNscDealerSearch}
                    component="button"
                  >
                    {props.t("dealerDeliveryBands.save")}
                  </Button>
                );
              }}
            />
          ) : (
            <PricesApplied
              success={true}
              text={props.t("dealerDeliveryBands.pricesApplied")}
            />
          )}
        </div>
      )}
    </ValidatorForm>
  );
};

export default DeliveryRangeTable;
